import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_DOWNLOAD_ENTRY_PROOF_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../../api';

export interface PostDownloadEntryProofRequest {
  uuid: string[];
}

export interface PostSearchEntryProofResponse {
  uuid: string;
}

interface Input {
  onSuccess?: (data: PostSearchEntryProofResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostDownloadEntryProof = ({ onSuccess, onError }: Input) => {
  const postSearchCandidate = async (payload: PostDownloadEntryProofRequest) => {
    const res = await axiosClient.post(POST_DOWNLOAD_ENTRY_PROOF_URL, payload);
    return res.data;
  };

  return useCustomMutation(postSearchCandidate, {
    onSuccess,
    onError,
  });
};
